import Navigator from "../../component/navigator";
import styles from "./index.module.scss";
import useDocumentTitle from "../../hooks/use-document-title";
const Qwerty = () => {
  useDocumentTitle("肌肉背单词");
  return (
    <>
      <Navigator activeKey="qwerty" />
      <iframe className={styles.iframe} src="https://edu.py2fun.com/qwerty" />
    </>
  );
};

export default Qwerty;
